import React, { useEffect } from "react";
import { AppHeader } from "../components/CommunitySelection";
import { useLang } from "../lib/i18n";
import { PRIVACY, TERMS } from "../lib/legal";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ doc }) {
  const { t, lang } = useLang();
  const data = doc === "privacy" ? PRIVACY : TERMS;
  const blocks = data.blocks[lang] || data.blocks.en;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[var(--page)]">
      <AppHeader subtitle={data.title[lang] || data.title.en} />
      <div className="max-w-3xl mx-auto px-5 sm:px-6 py-10 sm:py-12">
        <a
          href="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm text-ink-soft hover:text-vin transition-colors duration-200 mb-6"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={1.75} /> {t("Back to the app")}
        </a>

        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-ink leading-tight">
          {data.title[lang] || data.title.en}
        </h1>
        <p className="mt-2 text-sm text-ink-soft">{data.updated[lang] || data.updated.en}</p>

        <div className="mt-8 bg-white rounded-lg border border-[var(--line)] p-6 sm:p-8 space-y-1">
          {blocks.map((b, i) => {
            if (b.h) {
              return (
                <h2 key={i} className="font-display text-lg font-semibold text-vin-dark pt-5 first:pt-0">
                  {b.h}
                </h2>
              );
            }
            if (b.p) {
              return (
                <p key={i} className="text-[15px] text-ink leading-relaxed pt-2">
                  {b.p}
                </p>
              );
            }
            if (b.ul) {
              return (
                <ul key={i} className="pt-2 space-y-1.5">
                  {b.ul.map((li, j) => (
                    <li key={j} className="flex items-start gap-2.5 text-[15px] text-ink leading-relaxed">
                      <span className="mt-2 h-1.5 w-1.5 rounded-full bg-vin shrink-0" />
                      {li}
                    </li>
                  ))}
                </ul>
              );
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
}
